export default __webpack_public_path__ + "static/media/Hydra_Logo_White.35449688.png";